// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: '"Poppins"',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        // This applies globally
        '@global': {
          '*': {
            fontFamily: '"Poppins"',
          },
        },
      },
    },
  },
});

export default theme;